// ─────────────────────────────────────────────────────────────────────────────
// tokens/spacing.ts
//
// Escala de espaçamento baseada em 4px.
// Use para gap, padding e margin. Nunca valores arbitrários.
// ─────────────────────────────────────────────────────────────────────────────

export const spXs  = 4;   // '4px'
export const spSm  = 8;   // '8px'
export const spMd  = 12;  // '12px'
export const spLg  = 16;  // '16px'
export const spXl  = 20;  // '20px'
export const sp2xl = 24;  // '24px'
export const sp3xl = 32;  // '32px'
export const sp4xl = 48;  // '48px'

// Versões em string para CSS
export const spXs_  = '4px';
export const spSm_  = '8px';
export const spMd_  = '12px';
export const spLg_  = '16px';
export const spXl_  = '20px';
export const sp2xl_ = '24px';
export const sp3xl_ = '32px';
export const sp4xl_ = '48px';

export const spacing = {
  xs:  spXs,
  sm:  spSm,
  md:  spMd,
  lg:  spLg,
  xl:  spXl,
  '2xl': sp2xl,
  '3xl': sp3xl,
  '4xl': sp4xl,
} as const;
